var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid payment-panel"},[_c('button',{staticClass:"payment-button",style:(_vm.saveColor),attrs:{"disabled":_vm.disabled},on:{"click":_vm.saveTable}},[_vm._v(" SAVE "),_c('span',{staticClass:"w-100"},[_vm._v(_vm._s(_vm.$utils.formatCurrency((_vm.saleTotal - _vm.discount.total) / _vm.debtorCurrency.Rate, 4,``)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }